import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import { Promise } from "rsvp"

export default class StudentCourseDateRoute extends Route {
  @service("ember-store")
  store

  @service
  headData

  model(params) {
    this.headData.robots = "noindex"
    return new Promise((resolve, reject) => {
      get(this, "store")
        .find("course", params.course_id)
        .then((course) => {
          return get(this, "store")
            .find("planbook", course.relationships.planbook.data.id)
            .then((planbook) => {
              return get(this, "store")
                .find("rotation-calendar", planbook.relationships.rotationCalendar.data.id)
                .then((rotationCalendar) => {
                  resolve({
                    course: course,
                    planbook: planbook,
                    rotationCalendar: rotationCalendar,
                    dateString: params.date_string,
                  })
                })
            })
        })
    })
  }
}
